<app-page-title [title]="'Configure Email/Mailing preferences'"></app-page-title>
<div
    class="page"
    *ngIf="businessAccountTypeNameMapping$ | async as businessAccountTypeNameMapping"
>
    <div class="row">
        <div class="col-md-12">
            <strong>You may choose to send email/mail to your {{businessAccountTypeNameMapping.childTermName.toLowerCase()}} addresses or your main address.</strong><br />
            <strong>In order to receive multiple copies of a score report, please order additional reports.</strong>
            <br />
            <br />
            <ul>
                <li>
                    You may request that all emails sent to each {{businessAccountTypeNameMapping.childTermName.toLowerCase()}} email be also forwarded your contact email.
                </li>
                <li>
                    You may request that all mail <u>(including score reports)</u> sent to each {{businessAccountTypeNameMapping.childTermName.toLowerCase()}} address, be sent instead to your shipping address.
                </li>
            </ul>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <b>Where would you like the emails for your {{businessAccountTypeNameMapping.childTermName.toLowerCase()}} accounts to be sent?</b>
            <div class="radio">
                <label><input
                        type="radio"
                        name="emailAlsoToParent"
                        [(ngModel)]="emailAlsoToParent"
                        [value]="true"
                    >
                    Also send these emails to me</label>
            </div>
            <div class="radio">
                <label><input
                        type="radio"
                        name="emailAlsoToParent"
                        [(ngModel)]="emailAlsoToParent"
                        [value]="false"
                    >
                    Only send these emails to my {{businessAccountTypeNameMapping.childTermName.toLowerCase()}} accounts</label>
            </div>
        </div>
    </div>
    <br />
    <div class="row">
        <div class="col-md-12">
            <b>Where would you like the mail <u>(including score reports)</u> for your {{businessAccountTypeNameMapping.childTermName.toLowerCase()}} accounts to be sent? For mail/score reports to be sent to both, please order additional copies.</b>
            <div class="radio">
                <label><input
                        type="radio"
                        name="mailToParent"
                        [(ngModel)]="mailToParent"
                        [value]="true"
                    >
                    Send mail (including score reports) to me</label>
            </div>
            <div class="radio">
                <label><input
                        type="radio"
                        name="mailToParent"
                        [(ngModel)]="mailToParent"
                        [value]="false"
                    >
                    Send mail (including score reports) to my {{businessAccountTypeNameMapping.childTermName.toLowerCase()}} accounts</label>
            </div>
        </div>
    </div>
    <br />
    <div class="row">
        <div class="col-md-12">
            <button
                type="button"
                class="btn btn-primary m-1"
                name="confirmationYesBtn"
                (click)="saveNotificationConfig()"
            >
                <span *ngIf="processing"><i class="fa fa-spinner fa-spin"></i></span>
                Save Changes
            </button>
            <button
                type="button"
                name="resetBtn"
                class="btn btn-primary m-1"
                (click)="cancelChanges()"
            >
                Reset Changes
            </button>
        </div>
    </div>
    <app-modal
        #confirmSaveNotification
        [title]="modalTitle"
        [body]="modalBody"
    ></app-modal>
</div>
